import type { JobRunInput, JobRunKind } from "@/features/job/job-run/jobRun.types";
import { toJobRunText } from "@/features/job/job-run/jobRun.utils";
import { JobRunBuildOrderLineReport } from "./JobRunBuildOrderLineReport";

/** buildOrderLineReport in the run drawer. */
export const jobRunBuildOrderLineReport: JobRunKind = {
  Settings: JobRunBuildOrderLineReport,
  toInitialInput: (input) => {
    const initial: JobRunInput = {};
    const date = toJobRunText(input, "date");
    const since = toJobRunText(input, "since");
    if (date) initial.date = date;
    if (since) initial.since = since;
    return initial;
  },
  isComplete: () => true,
};
